import Grid from "@mui/material/Grid";
import ProductInput from "../../common/ProductInput";
import QuantityInput from "../../common/QuantityInput";
import { useRef } from "react";
import useEnterToAddRowAndFocus from "../../../../utils/useEnterToAddRowAndFocus";
import {
  maxLength,
  number,
  required,
  TextInput,
  useDataProvider,
} from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import { useFormContext } from "react-hook-form";
import parserFormatNumInput from "../../../../utils/parserFormatNumInput";
import {
  OptionRendererProduct,
  inputTextProduct,
  matchSuggestionProduct,
} from "../../../common/OptionRendererProduct";

const validateCode = [required(), maxLength(50)];
const validateQuantity = [required(), number()];

const CstInput = ({
  code,
  quantity,
  // Nama-nama source
  codeSource,
  quantitySource,
  nameSource,
  priceSource,
}) => {
  const { setValue, getValues } = useFormContext();
  const dataProvider = useDataProvider();

  // 🔹 Ambil data produk berdasarkan kode
  const onCodeChangeHandler = async (code) => {
    try {
      const { name, price } = await dataProvider.getListNoParams(
        "products/code-detail?code=" +
          encodeURIComponent(code) +
          "&date=" +
          encodeURIComponent(getValues("date"))
      );
      setValue(nameSource, name);
      setValue(priceSource, price.buy_price, { shouldValidate: true });
    } catch (error) {
      // optional: console.warn(error);
    }
  };

  // 🔹 Ref ke input Jumlah
  const quantityRef = useRef(null);

  useEnterToAddRowAndFocus(quantityRef, undefined, 'input[name*="code"]');

  return (
    <Grid
      container
      spacing={2}
      sx={{
        "& .MuiGrid-item": { py: 0 },
        mt: 0,
      }}
    >
      {/* Kolom kode produk */}
      <Grid item xs={12} lg={3}>
        <ProductInput
          fullWidth
          source={codeSource}
          variant="outlined"
          validate={validateCode}
          label="mine.label.product_code"
          optionText={<OptionRendererProduct />}
          inputText={inputTextProduct}
          matchSuggestion={matchSuggestionProduct}
          onChange={onCodeChangeHandler}
          dependOn="date"
          reset={[nameSource, priceSource]}
          helperText={false}
        />
      </Grid>

      {/* Kolom nama produk */}
      <Grid item xs={12} lg={4.5}>
        <TextInput
          variant="outlined"
          source={nameSource}
          label="mine.label.name"
          InputProps={{ readOnly: true }}
          fullWidth
          helperText={false}
        />
      </Grid>

      {/* Kolom harga */}
      <Grid item xs={12} lg={2.5}>
        <TextInput
          variant="outlined"
          source={priceSource}
          label="mine.label.price"
          fullWidth
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">Rp</InputAdornment>
            ),
            endAdornment: <InputAdornment position="end">/Box</InputAdornment>,
          }}
          helperText="harga beli sesuai tanggal yang dipilih"
          {...parserFormatNumInput}
        />
      </Grid>

      {/* Kolom jumlah */}
      <Grid item xs={12} lg={2} ref={quantityRef}>
        <QuantityInput
          variant="outlined"
          source={quantitySource}
          label="mine.label.quantity"
          fullWidth
          validate={validateQuantity}
          quantity={quantity}
          helperText={false}
        />
      </Grid>
    </Grid>
  );
};

// 🔹 Wrapper untuk digunakan di ArrayInput
const Inputs = ({
  formData,
  scopedFormData,
  getSource,
  ...rest
}) => {
  return (
    <CstInput
      {...scopedFormData}
      codeSource={getSource("code")}
      quantitySource={getSource("quantity")}
      nameSource={getSource("name")}
      priceSource={getSource("price")}
    />
  );
};

export default Inputs;

